var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"divide-y"},[_c('div',{staticClass:"block pr-6 py-4 text-gray-600",class:[
      _vm.isFocused ? 'bg-blue-100 font-bold' : 'bg-white',
      _vm.isFocused ? 'text-blue-800' : 'bg-white',
    ],style:({
      paddingLeft: `${_vm.indent * 1.5}rem`,
    }),on:{"click":function($event){return _vm.focusOrderItem(_vm.orderItem.uuid)}}},[_vm._v(" "+_vm._s(_vm.orderItem.name)+" ")]),(_vm.hasChildren)?_c('ul',{staticClass:"divide-y"},_vm._l((_vm.children),function(child){return _c('OrderItemNavItem',{key:child.uuid,attrs:{"order-item":child,"indent":_vm.indent + 1,"focused-order-item-id":_vm.focusedOrderItemId},on:{"order-line:focus":_vm.focusOrderItem}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }